export const DEAL_CREATION_TYPES = {
  1: 'Create From Scratch',
  2: 'Create From Zoho'
}

export const CREATE_FROM_SCRATCH = 1
export const CREATE_FROM_ZOHO = 2
